import isEmpty from 'lodash-es/isEmpty';

import { Address } from '@/models/address';

interface CompanyParam extends Address {
  zip?: string; // TODO: determine if zip is still relevant
}

/**
 * Formats the address of a company
 * @param company to format its address
 * @param isSingleLine should the address be formatted into a single line
 */
export default function formatAddress({
  company,
  isSingleLine = false,
}: {
  company: Partial<CompanyParam>;
  isSingleLine?: boolean;
}) {
  if (isEmpty(company)) {
    return '';
  }

  const zipcode = company.zipcode ?? company.zip;

  const line1 = [company.address, company.unitNumber].filter(Boolean).join(', ');
  const line2 = [company.city, company.state]
    .filter(Boolean)
    .join(', ')
    .concat(' ', zipcode || '');

  return [line1, line2].filter(Boolean).join(isSingleLine ? ', ' : '\n');
}
